module.exports = __webpack_public_path__ + "media/images/social/envelope-solid-469e9f8964e90167affb743a29bb5762.svg";